import React from "react";
import { Link } from "react-router-dom";

const DefaultNav = () => {
  return (
    <header className="header container">
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/">
            <span className="navbar-item">Home</span>
          </Link>
        </div>

        <div className="navbar-end">
          <Link to="/about">
            <span className="navbar-item">About</span>
          </Link>

          <Link to="/contact">
            <span className="navbar-item">Contact</span>
          </Link>

          <Link to="/somepage">
            <span className="navbar-item">404 Page</span>
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default DefaultNav;
